var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "addParticipantModal",
    attrs: {
      id: "add-participant-modal",
      "modal-dialog-size": _vm.componentAttributes.modalSize,
      "loaders-disabled": "",
      "modal-dialog-scrollable": false,
      "footer-close-button-text": _vm.$t("global.words.cancel"),
    },
    on: { hidden: _vm.resetData },
    scopedSlots: _vm._u(
      [
        {
          key: "header-custom",
          fn: function () {
            return [
              _c(
                "h5",
                { staticClass: "modal-title", attrs: { id: "modal-title" } },
                [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.componentAttributes.modalTitle) +
                      "\n    "
                  ),
                ]
              ),
            ]
          },
          proxy: true,
        },
        _vm.showResults
          ? {
              key: "body",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(
                        _vm.$t(
                          "direct-to-lender.commissions.commissionDetails.resultsMessage"
                        )
                      ) +
                      "\n\n    "
                  ),
                  _c(
                    "table-pagination",
                    {
                      attrs: {
                        limit: _vm.limit,
                        offset: _vm.offset,
                        total: _vm.results.length,
                      },
                      on: { "page-change": _vm.handlePageChange },
                    },
                    [
                      _c("v-client-table", {
                        ref: "participantsTable",
                        staticClass: "vue-custom-table no-pagination",
                        attrs: {
                          data: _vm.results,
                          options: _vm.options,
                          columns: _vm.options.columns,
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "fullName",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex align-items-center",
                                    },
                                    [
                                      _c(
                                        "profile-avatar",
                                        _vm._b(
                                          { staticClass: "client-avatar" },
                                          "profile-avatar",
                                          {
                                            id: "" + row.expertProfileId,
                                            givenName: row.firstName,
                                            familyName: row.lastName,
                                          },
                                          false
                                        )
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mx-2" }, [
                                        _c(
                                          "span",
                                          { staticClass: "bold text-grey" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm._f("fullName")({
                                                    givenName: row.firstName,
                                                    familyName: row.lastName,
                                                  })
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                            {
                              key: "brokerage",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(row.firmName) +
                                      "\n        "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "address",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.fullAddress(row.firmAddress)) +
                                      "\n        "
                                  ),
                                ]
                              },
                            },
                            {
                              key: "selected",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "pretty p-round p-default" },
                                    [
                                      _c("input", {
                                        attrs: {
                                          id:
                                            "selectRadio-" +
                                            row.expertProfileId,
                                          type: "radio",
                                          name:
                                            "select-agent-" +
                                            row.expertProfileId,
                                        },
                                        domProps: {
                                          checked:
                                            _vm.selectedParticipant
                                              .expertProfileId ===
                                            row.expertProfileId,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleSelectAgent(row)
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "state p-primary" },
                                        [
                                          _c("label", {
                                            attrs: {
                                              for:
                                                "selectRadio-" +
                                                row.expertProfileId,
                                              "aria-label": row.lastName,
                                            },
                                          }),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          705889390
                        ),
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            }
          : {
              key: "body",
              fn: function () {
                return [
                  _vm._v(
                    "\n    " +
                      _vm._s(
                        _vm.$t(
                          "direct-to-lender.commissions.commissionDetails.searchMessage"
                        )
                      ) +
                      "\n    "
                  ),
                  _c(
                    "material-input",
                    {
                      staticClass:
                        "form-group-material-no-label radio-form-transparent",
                    },
                    [
                      _c("radio-section", {
                        attrs: {
                          name: "selected-firm",
                          options: _vm.firmOptions,
                          "container-class": "row no-gutters",
                        },
                        model: {
                          value: _vm.ownFirmOnly,
                          callback: function ($$v) {
                            _vm.ownFirmOnly = $$v
                          },
                          expression: "ownFirmOnly",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("material-input", {
                    attrs: {
                      label: _vm.$t("application-form.first-name"),
                      "validator-context": _vm.v$,
                    },
                    model: {
                      value: _vm.firstName,
                      callback: function ($$v) {
                        _vm.firstName =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "firstName",
                    },
                  }),
                  _vm._v(" "),
                  _c("material-input", {
                    attrs: {
                      label: _vm.$t("application-form.last-name"),
                      "validator-context": _vm.v$,
                    },
                    model: {
                      value: _vm.lastName,
                      callback: function ($$v) {
                        _vm.lastName =
                          typeof $$v === "string" ? $$v.trim() : $$v
                      },
                      expression: "lastName",
                    },
                  }),
                ]
              },
              proxy: true,
            },
        {
          key: "footer",
          fn: function () {
            return [
              _c("notification-popover", {
                attrs: {
                  container: "#add-participant-modal",
                  boundary: "#add-participant-modal",
                  type: "warning",
                  disabled: !_vm.buttonWarning,
                },
                scopedSlots: _vm._u([
                  {
                    key: "popoverContent",
                    fn: function () {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "direct-to-lender.participants.syncSelectedAgentWarning"
                              )
                            )
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  },
                  {
                    key: "popoverTarget",
                    fn: function () {
                      return [
                        _c(
                          "simple-button",
                          {
                            ref: "submitDocument",
                            class: { "validation-button": _vm.buttonWarning },
                            attrs: {
                              "class-name": "bold btn-primary btn-sm",
                              disabled: _vm.v$.$invalid,
                              loading: _vm.loading,
                              "loading-succeeded": _vm.loadingSucceeded,
                            },
                            on: { click: _vm.handleSubmit },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.componentAttributes.nextButtonText) +
                                "\n          "
                            ),
                            _c("span", { staticClass: "validation-icon" }, [
                              _vm.buttonWarning
                                ? _c("i", {
                                    staticClass:
                                      "fa fa-exclamation-circle text-warning",
                                    attrs: { "aria-hidden": "true" },
                                  })
                                : _vm._e(),
                            ]),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
              }),
            ]
          },
          proxy: true,
        },
      ],
      null,
      true
    ),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }